import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimplePageComponent } from './pages/simple-page/simple-page.component';
import { RouterModule } from '@angular/router';
//import { IvyCarouselModule } from 'angular-responsive-carousel';
import { AngularMaterialModule } from 'src/app/shared/angular-material/angular-material.module';
import { SharedModule } from 'src/app/shared/components/shared.module';
//import { SlideGenericPageComponent } from './pages/slide-generic-page/slide-generic-page.component';
//import { ContentGenericPageComponent } from './pages/content-generic-page/content-generic-page.component';
import { VideoComponent } from './components/video/video.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { GeneralSimpleComponent } from './pages/general-simple/general-simple.component';
import { GeneralGalleryComponent } from './pages/general-gallery/general-gallery.component';
import { GeneralLandingComponent } from './pages/general-landing/general-landing.component';
import { HomeComponent } from './pages/home/home.component';
import { AlleventsComponent } from './pages/allevents/allevents.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CalendarCheckComponent } from './components/calendar-check/calendar-check.component';
import { FacultadesInstitutosComponent } from './components/facultades-institutos/facultades-institutos.component';
import { FacultadesComponent } from './pages/facultades/facultades.component';
import { ListDesplegableComponent } from './components/list-desplegable/list-desplegable.component';
import { TodasLasCarrerasComponent } from './components/todas-las-carreras/todas-las-carreras.component';
import { FormasDeContactoComponent } from './components/formas-de-contacto/formas-de-contacto.component';
import { CursosProximosComponent } from './components/cursos-proximos/cursos-proximos.component';
import { CursosDeExtensionComponent } from './components/cursos-de-extension/cursos-de-extension.component';
/* import { AreasDeConocimientoComponent } from '../../shared/components/areas-de-conocimiento/areas-de-conocimiento.component';
 */import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderLandingComponent } from './components/header-landing/header-landing.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { AutoridadesComponent } from './pages/autoridades/autoridades.component';
import { NotFountComponent } from './pages/not-fount/not-fount.component';
import { PorqueEstudiarEnUcaComponent } from './components/porque-estudiar-en-uca/porque-estudiar-en-uca.component';
import { PlanDeEstudioComponent } from './components/plan-de-estudio/plan-de-estudio.component';
import { PerfilProfesionalComponent } from './components/perfil-profesional/perfil-profesional.component';
import { InfoPosgradoCardComponent } from './components/info-posgrado-card/info-posgrado-card.component';
import { InfoColumnPosgradoComponent } from './components/info-column-posgrado/info-column-posgrado.component';
import { ResultadosCursosComponent } from './components/resultados-cursos/resultados-cursos.component';
import { PreUniversidadComponent } from './pages/pre-universidad/pre-universidad.component';
import { BuscadorPosgradosComponent } from 'src/app/modules/posgrados/components/buscador-posgrados/buscador-posgrados.component';
import { InternaPosgradoComponent } from '../posgrados/pages/interna-posgrado/interna-posgrado.component';
import { CardsPosgradosComponent } from '../posgrados/components/cards-posgrados/cards-posgrados.component';
import { InformacionPosgradosComponent } from '../posgrados/components/informacion-posgrados/informacion-posgrados.component';
import { SliderPosgradosComponent } from '../posgrados/components/slider-posgrados/slider-posgrados.component';
import { PosgradosGeneralDosComponent } from '../posgrados/pages/posgrados-general-dos/posgrados-general-dos.component';
import { PosgradosGeneralUnoComponent } from '../posgrados/pages/posgrados-general-uno/posgrados-general-uno.component';
import { PosgradosComponent } from '../posgrados/pages/posgrados/posgrados.component';
import { BuscadorCursosComponent } from '../cursos/componentes/buscador-cursos/buscador-cursos.component';
import { CursosListadoComponent } from '../cursos/pages/cursos-listado/cursos-listado.component';
import { CursosComponent } from '../cursos/pages/cursos/cursos.component';
import { BuscadorCarrerasComponent } from '../ingreso/components/buscador-carreras/buscador-carreras.component';
import { CarrerasDeGradoComponent } from '../ingreso/pages/carreras-de-grado/carreras-de-grado.component';
import { IngresoComponent } from '../ingreso/pages/ingreso/ingreso.component';
import { SedesIngresoComponent } from '../ingreso/pages/sedes-ingreso/sedes-ingreso.component';
import { HeaderSectionComponent } from 'src/app/shared/widgets/header-section/header-section.component';
import { NuestrasSedesComponent } from 'src/app/shared/widgets/nuestras-sedes/nuestras-sedes.component';
import { TextItemGeneralComponent } from 'src/app/shared/widgets/text-item-general/text-item-general.component';
import { CabeceraComponent } from 'src/app/shared/widgets/cabecera/cabecera.component';
import { CustomDiaryGeneralComponent } from 'src/app/shared/widgets/custom-diary-general/custom-diary-general.component';
import { CustomStatsGeneralComponent } from 'src/app/shared/widgets/custom-stats-general/custom-stats-general.component';
import { FormContactoComponent } from 'src/app/shared/widgets/form-contacto/form-contacto.component';
import { PostComponent } from 'src/app/shared/widgets/post/post.component';
import { PrimeraFotoDestacadaComponent } from 'src/app/shared/widgets/primera-foto-destacada/primera-foto-destacada.component';
import { VideoMasFormularioDosComponent } from 'src/app/shared/widgets/video-mas-formulario-dos/video-mas-formulario-dos.component';
import { VideoMasFormularioComponent } from 'src/app/shared/widgets/video-mas-formulario/video-mas-formulario.component';
import { CardsGeneralDosComponent } from 'src/app/shared/widgets/cards-general-dos/cards-general-dos.component';
import { CardsGeneralComponent } from 'src/app/shared/widgets/cards-general/cards-general.component';
import { CarrouselGeneralComponent } from 'src/app/shared/widgets/carrousel-general/carrousel-general.component';
import { ListaDeLinksComponent } from 'src/app/shared/widgets/lista-de-links/lista-de-links.component';
import { CarrouselImgComponent } from 'src/app/shared/widgets/carrousel-img/carrousel-img.component';
import { SliderGeneralComponent } from 'src/app/shared/widgets/slider-general/slider-general.component';
import { DetalleCursoComponent } from '../cursos/pages/detalle-curso/detalle-curso.component';
import { CodeQRComponent } from './components/code-qr/code-qr.component';
import { ServicesComponent } from './components/services/services.component';
import { VenuesComponent } from 'src/app/shared/widgets/venues/venues.component';
import { FormasDeContactoTresComponent } from 'src/app/shared/widgets/formas-de-contacto-tres/formas-de-contacto-tres.component';
import { ArancelesCursosComponent } from '../cursos/componentes/aranceles-cursos/aranceles-cursos.component';
import { PlanDeEstudioEducacionContinuaComponent } from '../cursos/componentes/plan-de-estudio-educacion-continua/plan-de-estudio-educacion-continua.component';
import { ArancelesPosgradoComponent } from '../posgrados/components/aranceles-posgrado/aranceles-posgrado.component';
import { PlanDeEstudioPosgradoComponent } from '../posgrados/components/plan-de-estudio-posgrado/plan-de-estudio-posgrado.component';
import { LazyRenderDirective } from 'src/app/shared/directives/lazyLoad.diective';
import { NuestraFacultadComponent } from 'src/app/shared/widgets/nuestra-facultad/nuestra-facultad.component';
import { MenuStickComponent } from 'src/app/shared/widgets/menu-stick/menu-stick.component';
import { PreguntasFrecuentesFacultdadComponent } from 'src/app/shared/components/preguntas-frecuentes-facultdad/preguntas-frecuentes-facultdad.component';


const ENTRYCOMPONENTS = [
  CarrouselGeneralComponent,
  CardsGeneralComponent,
  CardsGeneralDosComponent,
  CarrouselGeneralComponent,
  CarrouselImgComponent,
  ListaDeLinksComponent,
  ContactoComponent,
  TextItemGeneralComponent,
  CabeceraComponent,
  SliderGeneralComponent,
  CustomDiaryGeneralComponent,
  FormContactoComponent,
  CustomStatsGeneralComponent,
  PostComponent,
  PrimeraFotoDestacadaComponent,
  VideoMasFormularioComponent,
  CarrerasDeGradoComponent,


  HeaderSectionComponent,
  GeneralSimpleComponent,
  GeneralGalleryComponent,
  GeneralLandingComponent,
  HeaderLandingComponent,
  ListDesplegableComponent,
  FormasDeContactoTresComponent,
  VenuesComponent,
  LazyRenderDirective  

];
@NgModule({
  declarations: [
    ENTRYCOMPONENTS,
    SimplePageComponent,
  //  SlideGenericPageComponent,
   // ContentGenericPageComponent,
    CarrouselImgComponent,
    IngresoComponent,
    BuscadorCarrerasComponent,
    BuscadorPosgradosComponent,
    PosgradosComponent,
    VideoComponent,
    ContactoComponent,
    GeneralSimpleComponent,
    GeneralGalleryComponent,
    GeneralLandingComponent,
    HomeComponent,
    AlleventsComponent,
    CalendarComponent,
    CalendarCheckComponent,
    FacultadesInstitutosComponent,
    PosgradosGeneralUnoComponent,
    InformacionPosgradosComponent,
    PosgradosGeneralDosComponent,
    VideoMasFormularioDosComponent,
    FacultadesComponent,
    ListDesplegableComponent,
    TodasLasCarrerasComponent,
    FormasDeContactoComponent,
    CursosProximosComponent,
    CursosDeExtensionComponent,
    RedirectComponent,
    AutoridadesComponent,
    NotFountComponent,
    PorqueEstudiarEnUcaComponent,
    PlanDeEstudioComponent,
    PerfilProfesionalComponent,
    SliderPosgradosComponent,
    InfoPosgradoCardComponent,
    InfoColumnPosgradoComponent,
    CursosComponent,
    CursosListadoComponent,
    BuscadorCursosComponent,
    ResultadosCursosComponent,
    PreUniversidadComponent,
    NuestrasSedesComponent,
    ServicesComponent,
    CodeQRComponent,
    CardsPosgradosComponent,
    SedesIngresoComponent,
    InternaPosgradoComponent,
    DetalleCursoComponent,
    FormasDeContactoTresComponent,
    VenuesComponent,
    ArancelesCursosComponent,
    PlanDeEstudioEducacionContinuaComponent,
    ArancelesPosgradoComponent,
    PlanDeEstudioPosgradoComponent,
    
  ],
  //BORRAR LUEGO DE INTEGRAR WIDGETS DESDE EL BACK
  imports: [PreguntasFrecuentesFacultdadComponent,  MenuStickComponent, BrowserAnimationsModule, /*IvyCarouselModule,*/ CommonModule, SharedModule, RouterModule, AngularMaterialModule],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GeneralModule { }
